/*/*
 * Bundle « 2 paires » — NOCCA
 *
 * Trois rôles :
 *   1. basculer entre l'offre « 1 paire » (parcours natif du thème) et
 *      l'offre « 2 paires » (bouton dédié de ce bloc) ;
 *   2. proposer une 2e paire dont la couleur et la taille sont
 *      indépendantes de la première, sans jamais laisser choisir une
 *      combinaison épuisée. Par défaut elle est suggérée dans l'autre
 *      couleur (réglage `second_pair_suggestion` du snippet) ;
 *   3. ajouter les deux lignes au panier en une seule requête, puis
 *      demander à Shopify le HTML à jour du tiroir et de la pastille.
 *
 * Le prix remisé n'est pas calculé ici : il vient des remises
 * automatiques Shopify (voir le README). Ce fichier ne fait que
 * composer le bon panier.
 *
 * Les écouteurs sont posés sur `document` (délégation) : la fiche
 * produit réécrit une partie de son HTML à chaque changement de
 * variante, des écouteurs attachés aux éléments seraient perdus.
 */
(function () {
  if (window.__noccaBundleReady) return;
  window.__noccaBundleReady = true;

  var ROOT_SELECTOR = '[data-nocca-bundle]';
  var NATIVE_HIDDEN_CLASS = 'nocca-bundle-native-hidden';
  var FALLBACK_ERROR = "L'ajout au panier a échoué. Réessayez dans un instant.";
  var UNAVAILABLE_SUFFIX = ' — épuisé';

  /* ---------------------------------------------------------------- Données */

  function getData(root) {
    if (root.__noccaBundleData) return root.__noccaBundleData;

    var script = root.querySelector('[data-nocca-bundle-data]');
    if (!script) return null;

    try {
      root.__noccaBundleData = JSON.parse(script.textContent);
    } catch (error) {
      return null;
    }

    return root.__noccaBundleData;
  }

  // La fiche produit du thème : c'est là que vivent le sélecteur de
  // variante et le bouton d'ajout natif à masquer.
  function getScope(root) {
    return root.closest('product-info') || root.closest('.shopify-section') || document;
  }

  function findVariantByOptions(root, values) {
    var data = getData(root);
    if (!data || !values || !values.length) return null;

    for (var i = 0; i < data.variants.length; i++) {
      var variant = data.variants[i];
      if (variant.options.length !== values.length) continue;

      var matches = true;
      for (var j = 0; j < values.length; j++) {
        if (variant.options[j] !== values[j]) {
          matches = false;
          break;
        }
      }

      if (matches) return variant;
    }

    return null;
  }

  function findVariantById(root, id) {
    var data = getData(root);
    if (!data || !id) return null;

    for (var i = 0; i < data.variants.length; i++) {
      if (String(data.variants[i].id) === String(id)) return data.variants[i];
    }

    return null;
  }

  /* ------------------------------------------------------- 1re paire (thème) */

  // Le sélecteur du thème fait foi. On lit les valeurs cochées plutôt
  // que l'identifiant de variante : la valeur est à jour dès le clic,
  // sans dépendre de l'ordre des scripts du thème.
  function readFirstPairOptions(root) {
    var scope = getScope(root);
    var picker = scope.querySelector('variant-selects');
    var values = [];

    if (picker) {
      picker.querySelectorAll('.product-form__input').forEach(function (group) {
        var checked = group.querySelector('input[type="radio"]:checked');
        if (checked) {
          values.push(checked.value);
          return;
        }

        var select = group.querySelector('select');
        if (select) values.push(select.value);
      });

      if (!values.length) {
        picker.querySelectorAll('select').forEach(function (select) {
          values.push(select.value);
        });
      }
    }

    if (values.length) return values;

    // Repli : le champ caché du formulaire d'ajout au panier.
    var input = scope.querySelector('input[name="id"]');
    var variant = input && findVariantById(root, input.value);
    return variant ? variant.options.slice() : null;
  }

  function getFirstPairVariant(root) {
    return findVariantByOptions(root, readFirstPairOptions(root));
  }

  /* ---------------------------------------------------------- 2e paire (bloc) */

  function getSelects(root) {
    return Array.prototype.slice.call(root.querySelectorAll('[data-nocca-bundle-option]'));
  }

  function readSecondPairOptions(root) {
    return getSelects(root).map(function (select) {
      return select.value;
    });
  }

  function setSecondPairOptions(root, values) {
    if (!values) return;

    getSelects(root).forEach(function (select, index) {
      if (values[index] === undefined) return;
      select.value = values[index];
    });
  }

  // Une valeur reste sélectionnable s'il existe au moins une variante
  // disponible qui la combine aux autres choix en cours.
  function refreshAvailability(root) {
    var data = getData(root);
    if (!data) return;

    var selects = getSelects(root);
    var current = readSecondPairOptions(root);

    selects.forEach(function (select, index) {
      Array.prototype.slice.call(select.options).forEach(function (option) {
        if (!option.dataset.label) option.dataset.label = option.textContent.trim();

        var candidate = current.slice();
        candidate[index] = option.value;

        var variant = findVariantByOptions(root, candidate);
        var available = !!(variant && variant.available);

        option.disabled = !available;
        option.textContent = available ? option.dataset.label : option.dataset.label + UNAVAILABLE_SUFFIX;
      });
    });
  }

  // Valeurs possibles d'une option, dans l'ordre où elles apparaissent
  // parmi les variantes.
  function collectOptionValues(root, index) {
    var data = getData(root);
    var values = [];
    if (!data) return values;

    for (var i = 0; i < data.variants.length; i++) {
      var value = data.variants[i].options[index];
      if (value !== undefined && values.indexOf(value) === -1) values.push(value);
    }

    return values;
  }

  // Ce que le bloc propose pour la 2e paire tant que l'acheteur n'a pas
  // touché aux listes. En mode « complement », on suggère l'autre valeur
  // de l'option ciblée (la couleur) à taille égale : deux paires qui
  // tournent plutôt que deux fois la même. On ne suggère jamais une
  // combinaison épuisée : dans ce cas on retombe sur la copie de la 1re
  // paire, le comportement d'origine.
  function suggestSecondPairOptions(root, firstVariant) {
    var data = getData(root);
    var fallback = firstVariant.options.slice();

    if (!data || data.suggestion !== 'complement') return fallback;

    var index = data.suggestionOptionIndex;
    if (typeof index !== 'number' || firstVariant.options[index] === undefined) return fallback;

    var values = collectOptionValues(root, index);

    for (var i = 0; i < values.length; i++) {
      if (values[i] === firstVariant.options[index]) continue;

      var candidate = firstVariant.options.slice();
      candidate[index] = values[i];

      var variant = findVariantByOptions(root, candidate);
      if (variant && variant.available) return candidate;
    }

    return fallback;
  }

  /* ------------------------------------------------------------- Affichage */

  function getOffer(root) {
    var checked = root.querySelector('[data-nocca-bundle-offer]:checked');
    return checked ? checked.value : 'single';
  }

  function toggleNativeButtons(root, hide) {
    var scope = getScope(root);
    if (scope === document) return;

    scope.querySelectorAll('.product-form__buttons').forEach(function (node) {
      node.classList.toggle(NATIVE_HIDDEN_CLASS, hide);
      if (hide) {
        node.setAttribute('aria-hidden', 'true');
      } else {
        node.removeAttribute('aria-hidden');
      }
    });
  }

  function showError(root, message) {
    var target = root.querySelector('[data-nocca-bundle-error]');
    if (!target) return;
    target.textContent = message;
    target.hidden = false;
  }

  function hideError(root) {
    var target = root.querySelector('[data-nocca-bundle-error]');
    if (!target) return;
    target.textContent = '';
    target.hidden = true;
  }

  function setLoading(root, isLoading) {
    root.classList.toggle('is-loading', isLoading);
    var button = root.querySelector('[data-nocca-bundle-add]');
    if (button) button.setAttribute('aria-busy', isLoading ? 'true' : 'false');
  }

  // Vignettes : image et libellé de chaque paire.
  function updatePreview(root, key, variant) {
    var image = root.querySelector('[data-nocca-bundle-preview="' + key + '"]');
    var title = root.querySelector('[data-nocca-bundle-pair-title="' + key + '"]');

    if (image && variant && variant.image && image.getAttribute('src') !== variant.image) {
      image.setAttribute('src', variant.image);
    }

    if (title) title.textContent = variant ? variant.title : '';
  }

  function render(root) {
    var isDuo = getOffer(root) === 'duo';
    var second = root.querySelector('[data-nocca-bundle-second]');
    var button = root.querySelector('[data-nocca-bundle-add]');
    var firstVariant = getFirstPairVariant(root);

    if (second) second.hidden = !isDuo;
    if (button) button.hidden = !isDuo;
    toggleNativeButtons(root, isDuo);

    if (!isDuo) {
      hideError(root);
      return;
    }

    // Tant que l'acheteur n'a pas touché aux listes, la 2e paire est
    // (re)suggérée à partir de la première, y compris quand celle-ci
    // change de couleur ou de taille plus haut.
    if (!root.__noccaBundleTouched && firstVariant && firstVariant.available) {
      setSecondPairOptions(root, suggestSecondPairOptions(root, firstVariant));
    }

    refreshAvailability(root);

    var secondVariant = findVariantByOptions(root, readSecondPairOptions(root));

    updatePreview(root, 'first', firstVariant);
    updatePreview(root, 'second', secondVariant);

    if (button) {
      var blocked = !firstVariant || !firstVariant.available || !secondVariant || !secondVariant.available;
      button.disabled = blocked;
    }

    if (firstVariant && !firstVariant.available) {
      showError(root, 'La 1re paire choisie est épuisée. Changez de couleur ou de taille plus haut.');
    } else if (!secondVariant || !secondVariant.available) {
      showError(root, "Cette combinaison n'est plus disponible pour la 2e paire.");
    } else {
      hideError(root);
    }
  }

  /* --------------------------------------------------------- Ajout au panier */

  function getSectionIds(drawer) {
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      return drawer.getSectionsToRender().map(function (section) {
        return section.id;
      });
    }
    return ['cart-drawer', 'cart-icon-bubble'];
  }

  function addBundle(root) {
    if (root.classList.contains('is-loading')) return;

    var quantity = parseInt(root.getAttribute('data-bundle-quantity'), 10) || 2;
    var firstVariant = getFirstPairVariant(root);
    var secondVariant = findVariantByOptions(root, readSecondPairOptions(root));

    if (!firstVariant || !firstVariant.available || !secondVariant || !secondVariant.available) {
      render(root);
      return;
    }

    // Deux fois la même variante : Shopify fusionnerait les lignes de
    // toute façon, autant envoyer une seule ligne quantité 2.
    var items =
      firstVariant.id === secondVariant.id
        ? [{ id: firstVariant.id, quantity: quantity }]
        : [
            { id: firstVariant.id, quantity: 1 },
            { id: secondVariant.id, quantity: 1 },
          ];

    var drawer = document.querySelector('cart-drawer');
    var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';

    hideError(root);
    setLoading(root, true);

    fetch(addUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/javascript',
      },
      body: JSON.stringify({
        items: items,
        sections: getSectionIds(drawer).join(','),
        sections_url: window.location.pathname,
      }),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        // Shopify ne renvoie un `status` qu'en cas d'erreur (rupture, etc.).
        if (data.status) {
          setLoading(root, false);
          showError(root, data.description || data.message || FALLBACK_ERROR);
          return;
        }

        setLoading(root, false);

        if (drawer && data.sections) {
          drawer.renderContents(data);
        } else {
          window.location = (window.routes && window.routes.cart_url) || '/cart';
        }
      })
      .catch(function () {
        setLoading(root, false);
        showError(root, FALLBACK_ERROR);
      });
  }

  /* ---------------------------------------------------------- Branchements */

  document.addEventListener('change', function (event) {
    if (!(event.target instanceof Element)) return;

    var root = event.target.closest(ROOT_SELECTOR);

    if (root) {
      if (event.target.matches('[data-nocca-bundle-option]')) {
        root.__noccaBundleTouched = true;
      }
      render(root);
      return;
    }

    // Changement de variante côté thème : la 1re paire a bougé.
    var scope = event.target.closest('product-info') || event.target.closest('.shopify-section');
    if (!scope) return;

    scope.querySelectorAll(ROOT_SELECTOR).forEach(render);
  });

  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;

    var button = event.target.closest('[data-nocca-bundle-add]');
    if (!button) return;

    event.preventDefault();
    addBundle(button.closest(ROOT_SELECTOR));
  });

  function init() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(render);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Personnalisateur de thème : la section est réinjectée à chaque réglage.
  document.addEventListener('shopify:section:load', init);
})();
